import React, { memo } from 'react';
import { clsx } from 'helpers/utils/HTMLUtils';
import './BannerPesquisaCpfCnpj.scss';
import { Input } from 'plataforma-fundacao-componentes';
import { InputProps } from 'plataforma-fundacao-componentes/dist/components/input/Input';
const rootClassName = 'banner-pesquisa-cpf-cnpj';

interface BannerPesquisaCpfCnpjProps {
  title?: string;
  subtitle?: string;
  inputProps?: InputProps;
  urlImg?: string;
  theme?: 'white' | 'secondary-light' | 'secondary-lighter';
  captcha?: React.ReactNode;
}

function BannerPesquisaCpfCnpj(props: BannerPesquisaCpfCnpjProps) {
  return (
    <div
      className={clsx([rootClassName, props?.theme! ?? 'secondary-lighter'])}
    >
      <div
        className={clsx([`${rootClassName}-left`, props.captcha ? 'plus' : ''])}
      >
        <div className={`${rootClassName}-title`}>{props.title}</div>
        <div className={`${rootClassName}-sub-title nunito`}>
          {props.subtitle}
        </div>
        {props.inputProps ? (
          <div className={`${rootClassName}-input`}>
            <Input {...props.inputProps} />
          </div>
        ) : undefined}
        {props.captcha ? (
          <div className={`${rootClassName}-captcha`}>{props.captcha}</div>
        ) : undefined}
      </div>
      <div
        className={clsx([
          `${rootClassName}-image`,
          props.captcha ? 'plus' : '',
        ])}
        style={{ backgroundImage: `url(${props.urlImg})` }}
      >
        <img alt='img' src={props.urlImg} />
      </div>
    </div>
  );
}

export default memo(BannerPesquisaCpfCnpj);
